import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";

class ChargeTypeUpdate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    let chargeType = props.res;

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_UPDATE_SUCCESS,
      payload: {
        chargeType
      }
    });

    this.props.dispatch({
      type: Constants.GLOBAL_RECEIVE_DATA_TYPES_LIST
    });
  }

}

export { ChargeTypeUpdate };
